var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalander(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_154_1",
    "data-name": "Component 154 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8122",
    "data-name": "Path 8122",
    d: "M12,19a1,1,0,1,0-.707-.293A1,1,0,0,0,12,19Zm5,0a1,1,0,1,0-.707-.293A1,1,0,0,0,17,19Zm0-4a1,1,0,1,0-.707-.293A1,1,0,0,0,17,15Zm-5,0a1,1,0,1,0-.707-.293A1,1,0,0,0,12,15ZM19,3H18V2a1,1,0,0,0-2,0V3H8V2A1,1,0,1,0,6,2V3H5A3,3,0,0,0,2,6V20a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V6a3,3,0,0,0-3-3Zm1,17a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V11H20ZM20,9H4V6A1,1,0,0,1,5,5H6V6A1,1,0,1,0,8,6V5h8V6a1,1,0,0,0,2,0V5h1a1,1,0,0,1,1,1ZM7,15a1,1,0,1,0-.707-.293A1,1,0,0,0,7,15Zm0,4a1,1,0,1,0-.707-.293A1,1,0,0,0,7,19Z",
    transform: "translate(-2 -1)",
    fill: "#023f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalander);
export default __webpack_public_path__ + "static/media/calander.0c15b178d662f7d6564ec33f9d49e224.svg";
export { ForwardRef as ReactComponent };